module.exports = __webpack_public_path__ + "media/packs/autocatalog/components/mobile/SpecSummary/images/engine-115d689c20ba034f2ae7b87c5b53d734.png";